// Formatting for the Engagement tab (ticket-2542). Copy follows the Claude Design exactly:
// counts read "+62 vs. previous month", the rate card "+9% from previous month" (a point
// difference shown with %), and the table's Change column "+8 pts". All time has no previous
// period, so it gets no comparison at all.

export const ALL_TIME = -1;

const PREVIOUS_PERIOD: Record<number, string> = {
  7: 'previous week',
  30: 'previous month',
  180: 'previous 6 months',
  365: 'previous 12 months',
};

export const hasComparison = (daysAgo: number) => daysAgo !== ALL_TIME;

// Pet parents get 30 days of support from their invite (sms_sync_date).
export const SUPPORT_DAYS = 30;

// The tab only counts pet parents whose support has finished, the same cohort as the
// dashboard's engagement-rate card (invited 30-60 days ago for "Last month"). So a period of
// N days is the parents whose support ended in the last N days: invited between N + 30 and 30
// days ago. The previous period is the N + 1 days before that, so the two never share a day.
// All time is everyone whose support has ended, with no comparison.
export const periodVariables = (daysAgo: number) => (daysAgo === ALL_TIME
  ? { allTime: true, endDaysAgo: SUPPORT_DAYS }
  : {
    allTime: false,
    startDaysAgo: daysAgo + SUPPORT_DAYS,
    endDaysAgo: SUPPORT_DAYS,
    previousStartDaysAgo: daysAgo * 2 + SUPPORT_DAYS + 1,
    previousEndDaysAgo: daysAgo + SUPPORT_DAYS + 1,
  });

// Rounded percentage; 0 rather than NaN when there is nobody to divide by.
export const percentOf = (part: number, whole: number) => (whole > 0 ? Math.round((part / whole) * 100) : 0);

// "612 lessons", "1 lesson".
export const countOf = (n: number, noun: string) => `${n.toLocaleString()} ${noun}${n === 1 ? '' : 's'}`;

export const signed = (n: number) => `${n > 0 ? '+' : ''}${n.toLocaleString()}`;

export const countDelta = (current: number, previous: number, daysAgo: number) => (
  hasComparison(daysAgo) ? `${signed(current - previous)} vs. ${PREVIOUS_PERIOD[daysAgo]}` : undefined
);

export const rateDelta = (currentRate: number, previousRate: number, daysAgo: number) => (
  hasComparison(daysAgo) ? `${signed(currentRate - previousRate)}% from ${PREVIOUS_PERIOD[daysAgo]}` : undefined
);

export const pointsChange = (currentRate: number, previousRate: number, daysAgo: number) => (
  hasComparison(daysAgo) ? `${signed(currentRate - previousRate)} pts` : '—'
);

// Delta captions are teal unless the change is negative.
export const isNegative = (delta?: string) => !!delta && delta.startsWith('-');
